import { updateWidgetCache } from "../../../../util/Scripts";
export class KanbanScripts {
   //used before saving item changes by forms POST
   static convertItemToSave = (item, columns) => {
      let itemCopy = {};

      Object.keys(item).forEach((key) => {
         const enumType = columns.find(({ title }) => key === title)?.enumType;

         if (key !== "key" && KanbanScripts.getTechNameFromTitle(key, columns) !== undefined) {
            if (enumType === "sql") {
               itemCopy[KanbanScripts.getTechNameFromTitle(key, columns)] = item[key]?.value ?? "";
            } else if (enumType === "dict") {
               itemCopy[KanbanScripts.getTechNameFromTitle(key, columns)] = item[key]?.id ?? "";
            } else {
               itemCopy[KanbanScripts.getTechNameFromTitle(key, columns)] = item[key];
            }
         }
      });
      delete itemCopy?.recordId;

      return itemCopy;
   };

   //used for changin value in kanban item after it was moved
   static editMovedItemValue = (value, item, destination, destinationItems, columns) => {
      const itemName = KanbanScripts.getTitleFromTechName(value.verticalPlacement, columns);
      const enumType = columns.find(
         ({ techName }) => value.verticalPlacement == techName,
      )?.enumType;

      const getValueFromDestinationItems = (itemName, index) => {
         if (enumType === "int") {
            return destinationItems[index][itemName] == "" ||
               isNaN(destinationItems[index][itemName])
               ? 0
               : parseInt(destinationItems[index][itemName]);
         }
         if (enumType === "date_time") {
            return Date.parse(destinationItems[index][itemName]) || 0;
         }
      };

      if (
         enumType !== "int" &&
         enumType !== "date_time" &&
         enumType !== "time" &&
         enumType !== "date"
      ) {
         return item;
      }

      let elementValue, neighbourValue, difference;

      if (destination.index == 0 || destination.index == destinationItems.length) {
         const index = destination.index == 0 ? 0 : destinationItems.length - 1;

         if (enumType === "int") {
            elementValue =
               destinationItems[index][itemName] == "" || isNaN(destinationItems[index][itemName])
                  ? 0
                  : parseInt(item[itemName]);
            neighbourValue = getValueFromDestinationItems(itemName, index);
            difference = 1;
         }
         if (enumType === "date_time") {
            elementValue = Date.parse(item[itemName]) || 0;
            neighbourValue = getValueFromDestinationItems(itemName, index);
            difference = 3600 * 24 * 1000;
         }

         const shouldChangeValue =
            (destination.index == 0
               ? elementValue >= neighbourValue
               : elementValue <= neighbourValue) == value.sortRows;

         if (shouldChangeValue) {
            const whatToAdd =
               ((value.sortRows && destination.index == 0) ||
               (!value.sortRows && destination.index != 0)
                  ? -1
                  : 1) * difference;

            item[itemName] = getValueFromDestinationItems(itemName, index) + whatToAdd;
         }
      } else {
         item[itemName] = Math.floor(
            (getValueFromDestinationItems(itemName, destination.index - 1) +
               getValueFromDestinationItems(itemName, destination.index)) /
               2,
         );
      }

      if (enumType == "date_time" && typeof item[itemName] == "number") {
         item[itemName] = convertNumberToTime(item[itemName]);
      }

      return item;
   };

   static getTechNameFromTitle = (title, columns) => {
      return columns.find((column) => column.title === title)?.techName;
   };

   static getTitleFromTechName = (techName, columns) => {
      return columns.find((column) => column.techName === techName)?.title;
   };

   static handleHidingColumn = (widgetId, widgetName, columnId, widgetCache) => {
      updateWidgetCache(widgetId, widgetName, {
         ...widgetCache,
         hiddenColumns: widgetCache.hiddenColumns.find((hiddenColumn) => hiddenColumn == columnId)
            ? [...widgetCache.hiddenColumns.filter((hiddenColumn) => hiddenColumn != columnId)]
            : [...widgetCache.hiddenColumns, columnId],
      });
   };

   //used for scrolling in mobile version of kanban
   static scrollKanban = (direction, elementWidth) => {
      const container = document.querySelector("#container-for-list-" + value.id);
      container.scrollLeft += (direction == "left" ? -1 : 1) * (elementWidth + 16);
   };

   //creates inital columns for kanban, sets values to columns for sql/dicitonary fields, and filters columns that should not be visible.
   static createColumnsFromResponse = (columns, formStructure, listId) => {
      const columnsCopy = [];
      columns.forEach((column) => {
         if (
            (column.options.visible == "1" ||
               column.options.resolver ||
               !!column.options.visible) &&
            (column.options.techName || column.techName)
         ) {
            let element;
            if (listId.length > 10) {
               element = Object.values(formStructure.fields).find(
                  (element) => element.id === column?.techName,
               );
            } else {
               element = Object.values(formStructure.forms_data.tab[0].elements).find(
                  (element) => element.tech_name === column?.options?.techName,
               );
            }

            if (listId.length > 10) {
               columnsCopy.push({
                  title: column?.label,
                  dataIndex: column?.label,
                  techName: column?.options?.techName ?? column.techName,
                  selectEntries: column?.meta?.selectEntries,
               });
            } else {
               columnsCopy.push({
                  title: column?.label,
                  dataIndex: column?.label,
                  techName: column?.options?.techName ?? column.techName,
                  precision: column?.options?.precision,
                  values:
                     column?.options?.enumType === "sql"
                        ? [
                             ...element?.sqlValues?.map((sqlValue) => ({
                                [sqlValue.value]: sqlValue.label,
                             })),
                          ]
                        : element?.sortedOptions,
                  enumType: column?.options?.enumType,
               });
            }
         }
         return null;
      });
      return columnsCopy;
   };

   //creates initial rows for kanban using response from list, it's apllying url filters, adding precision to numbers, adding keys, etc.
   static createRowsFromResponse = (data, columns, widgetSettings) => {
      let actionType;
      let actionBy;
      let actionValues;

      if (window?.location) {
         const urlParams = new URLSearchParams(window.location.search);

         if (urlParams.get("widgetId") === widgetSettings.id) {
            actionType = urlParams.get("actionType");
            actionBy = urlParams.get("actionBy");
            actionValues = urlParams.get("actionValues");
         }
      }

      let rowsTable = data.map((row) => {
         // Beacuse we use labels in row as keys, we can't just compare it to actionBy from URL, so we need to use
         // shouldSkip to stop the loop if the row is invalid to filtering requirements
         let shouldSkip = false;

         const obj = {};
         columns.forEach((column) => {
            // Filtering from URL
            if (actionType && actionBy && actionValues && column.techName === actionBy) {
               if (actionType === "filter") {
                  if (typeof row[column.dataIndex] === "object") {
                     if (row[column.dataIndex].id !== actionValues) {
                        shouldSkip = true;
                     }
                  } else if (row[column.dataIndex] !== actionValues) {
                     shouldSkip = true;
                  }
               }
            }

            if (!shouldSkip) {
               if (typeof row[column.dataIndex] === "string") {
                  let rowValue = Number(row[column.dataIndex]);
                  // This has to check if rowValue is an empty string or not, because Number() makes converts empty string to 0
                  if (
                     row[column.dataIndex] &&
                     column.precision &&
                     row[column.dataIndex].length > 0 &&
                     !isNaN(rowValue)
                  ) {
                     obj[column.dataIndex] = rowValue
                        .toFixed(column.enumType === "dec" ? column.precision : 0)
                        .toString();
                  } else {
                     obj[column.dataIndex] = row[column.dataIndex];
                  }
               } else {
                  obj[column.dataIndex] = row[column.dataIndex];
               }
            }
            if (column.enumType === "int") {
               obj[column.dataIndex] =
                  isNaN(obj[column.dataIndex]) || obj[column.dataIndex] == ""
                     ? 0
                     : parseFloat(obj[column.dataIndex]);
            }
         });
         if (shouldSkip) {
            return;
         }

         //I'm adding recordId because we need that to open form in modal, when I'm saving by saveForm i'm deleting recordId.
         if (row?.["api_rowMetaData"]?.recordId !== undefined) {
            obj.recordId = row.api_rowMetaData?.recordId;
         } else if (row?.["UID"] !== undefined) {
            obj.recordId = row.UID;
         }

         if (Array.isArray(row?.["api_instanceStatus"])) {
            obj["api_instanceStatus"] = row["api_instanceStatus"];
         }

         return obj;
      });

      // After mapping the rowsTable, we need to filter out the invalid rows.
      // TODO: after we change using keys in lists from labels to technames, refactor it to just filter out
      // values from proper technames

      rowsTable = rowsTable.filter((row) => row !== undefined);

      rowsTable.forEach((row, i) => {
         row.key = i;
      });
      return rowsTable;
   };

   static validColumnsForHorizontalPlacement = (columns) => {
      return columns.filter(
         ({ enumType, selectEntries }) => enumType == "dict" || enumType === "sql" || selectEntries,
      );
   };
}

const convertNumberToTime = (value) => {
   value = Math.floor(value / (1000 * 24 * 3600)) * (1000 * 24 * 3600);
   value = new Date(value);
   value = value.toISOString().split("T");
   const date = value[0];
   const time = value[1].split(".")[0];

   return (date + " " + time).toString();
};
